import React from 'react'
import styled from 'styled-components'
import FieldDescription from './FieldDescription'
import { UIStyles, surfaces } from '../../theme'
import SelectedFieldsTabsContainer from '../../containers/FieldsContainers/SelectedFieldsTabsContainer'

const Wrapper = styled.div`
  top: 60px;
  left: 60px;
  position: fixed;
  z-index: 4;
  width: 360px;
  display: flex;
  background-color: ${UIStyles.blueColorOpacity};
  -webkit-backdrop-filter: ${surfaces.glassBackdropFilter};
  backdrop-filter: ${surfaces.glassBackdropFilter};
  box-shadow: ${surfaces.dockedCardShadow};
  flex-direction: column;
  overflow: hidden;
  height: ${props => (props.asideExpanded ? 'min-content' : 'auto')};
  max-height: calc(100vh - 60px);
  transition: height 0.3s ease, max-height 0.3s ease;
  border-bottom-right-radius: 12px;
`

const TabsAndContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
`

function SelectedFieldsAside({
  shouldShowSamplesInMap,
  toggleExpandSelectedFieldAside,
  toggleShowSampleMarkers,
  fields,
  temporal,
  flightGroups,
  openSearchMode,
  closeEditMode,
  asideExpanded,
  fetchActiveFieldsSamples,
  samplesMode,
  setSamplesMode,
  surfaceUnit,
  hasSamples,
  selectedFlightGroupDate
}) {
  return (
    <Wrapper asideExpanded={asideExpanded}>
      <FieldDescription
        asideExpanded={asideExpanded}
        toggleExpandSelectedFieldAside={toggleExpandSelectedFieldAside}
        shouldShowSamplesInMap={shouldShowSamplesInMap}
        toggleShowSampleMarkers={toggleShowSampleMarkers}
        fields={fields}
        temporal={temporal}
        flightGroups={flightGroups}
        openSearchMode={openSearchMode}
        closeEditMode={closeEditMode}
        fetchActiveFieldsSamples={fetchActiveFieldsSamples}
        samplesMode={samplesMode}
        setSamplesMode={setSamplesMode}
        surfaceUnit={surfaceUnit}
        hasSamples={hasSamples}
        selectedFlightGroupDate={selectedFlightGroupDate}
      />
      <TabsAndContentWrapper>
        <SelectedFieldsTabsContainer asideExpanded={asideExpanded} />
      </TabsAndContentWrapper>
    </Wrapper>
  )
}

export default SelectedFieldsAside
